import * as React from 'react';

import './footer.scss';
import Particles from "react-tsparticles";
import subservices from '../Header/subservices';
import { Link } from 'gatsby';
import isBrowser from '../isBrowser';

const Footer = () => {

    const menu = { 
        "Advanced penetration testing": subservices["Advanced penetration testing"], 
        "Services & support" : subservices["Services & support"], 
        "Solutions" : subservices["Solutions"], 
        "Company": [
            { title : "About us", path:"/about_us"},
            { title : "Contact us", path:"/contact_us"},
            { title : "Pricing", path:"/pricing"},
            { title : "Resources", path:"https://ulogx.com/", externalLink:true},
            { title : "Privacy Policy", path:"/"},
            { title : "Terms & Conditions", path:"/"},
            { title : "Sitemap", path:"/sitemap/sitemap-0.xml"},
        ]
    }

    const linksColumn = Object.keys(menu).map((keyName, index) => {

        return (
            keyName && keyName !== "Compliance management" && 
            <ul className="links-column" key={index}>
                <li className="name">{ keyName }</li>
                <ul>
                    {
                        menu[keyName] && 
                        menu[keyName].map((service, j)=>(
                            <li  key={j}>
                                {
                                    service.externalLink ? 
                                    <a href={service.path} target="_blank" rel="noopener noreferrer">
                                        <i className="fa fa-angle-right"></i> {service.title}
                                    </a>
                                    :
                                    <Link to={service.path}>
                                        <i className="fa fa-angle-right"></i> {service.title}
                                    </Link>
                                }
                            </li>
                        ))
                    }
                </ul>
            </ul>
        )
    });

    return (
        <footer className="footer-section">
            <div className="particles">
                {
                    isBrowser() && <Particles
                        id="tsparticles"
                        options={{
                            fpsLimit: 60,
                            interactivity: {
                                detectsOn: "canvas",
                                events: {
                                    onClick: {
                                        enable: true,
                                        mode: "push",
                                    },
                                    onHover: {
                                        enable: true,
                                        mode: "repulse",
                                    },
                                    resize: true,
                                },
                                modes: {
                                    bubble: {
                                        distance: 400,
                                        duration: 20,
                                        opacity: 0.8,
                                        size: 10,
                                    },
                                    push: {
                                        quantity: 4,
                                    },
                                    repulse: {
                                        distance: 200,
                                        duration: 60,
                                    },
                                },
                            },
                            particles: {
                                color: {
                                    value: "#ffffff",
                                },
                                links: {
                                    color: "#ffffff",
                                    distance: 80,
                                    enable: true,
                                    opacity: 0.5,
                                    width: 1,
                                },
                                collisions: {
                                    enable: true,
                                },
                                move: {
                                    direction: "none",
                                    enable: true,
                                    outMode: "bounce",
                                    random: false,
                                    speed: 2,
                                    straight: false,
                                },
                                number: {
                                    density: {
                                        enable: true,
                                        value_area: 800,
                                    },
                                    value: 80,
                                },
                                opacity: {
                                    value: 0.5,
                                },
                                shape: {
                                    type: "circle",
                                },
                                size: {
                                    random: true,
                                    value: 2,
                                },
                            },
                            detectRetina: true,
                        }}
                    />
                }
            </div>
            <section className="content">
                <div className="content-header">
                    <div className="row">
                        <div className="col l6 m12">
                            <span>
                                <h1 className="title">MrPentester - Arka</h1>
                                <h1 className="tagline">Attack. Fix. Repeat.</h1>
                            </span>
                        </div>
                        <div className="col l6 m12">
                            <span>
                                <a href="http://calendly.com/mrpentester/30min?month=2021-05" target="__blank" className="schedule">
                                    Schedule Meeting
                                </a>
                                <Link to="/request-a-free-trial" className="trial">
                                    Request a Free Trial
                                </Link>
                                <div className="newsletter">
                                    <p>Subscribe Newsletter</p>
                                    <form action="https://submit-form.com/VS5BDNhE">
                                        <div className="input">
                                            <input type="email" name="email" id="email" required placeholder="Enter Email" />
                                            <button type="submit">Send</button>
                                        </div>
                                    </form>
                                </div>
                            </span>
                        </div>
                    </div>
                </div>
                <div className="links-div">
                    <div className="links-row">
                        {linksColumn}
                    </div>
                </div>
                <div className="credit-div">
                    <div className="row">
                        <div className="col">
                            <h1>Copyright MrPentester & Chillitray Technologies © 2020 - 2021 | All Rights Reserved</h1>
                        </div>
                        <div className="col social-media">
                            <ul className="social-media-links">
                                <li>
                                    <a href="https://twitter.com/MrPentester" target="_blank" rel="noopener noreferrer">
                                        <i className="fab fa-twitter"></i>
                                    </a>
                                </li>

                                <li>
                                    <a href="https://www.facebook.com/MrPentester/" target="_blank" rel="noopener noreferrer">
                                        <i className="fab fa-facebook"></i>
                                    </a>
                                </li>
                                
                                <li>
                                    <a href="https://www.instagram.com/mrpentesters/" target="_blank" rel="noopener noreferrer">
                                        <i className="fab fa-instagram"></i>
                                    </a>
                                </li>
                                
                                <li>
                                    <a href="https://www.linkedin.com/company/mrpentester" target="_blank" rel="noopener noreferrer">
                                        <i className="fab fa-linkedin"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="mailto:contact@mrpentester.com">
                                        <i className="fas fa-envelope"></i>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        </footer>
    );
}

export default Footer;